import React from "react";
import { Facebook, Twitter, Linkedin, Instagram, MapPin, Phone, Mail } from "lucide-react";

export default function Footer() {
  return (
    <footer className="ft">
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800;900&display=swap');
        :root{
          --blue:#2563eb;--blue2:#3b82f6;--black:#080808;
          --bdd:rgba(255,255,255,.07);--txm:rgba(255,255,255,.35);
          --f:'Inter',sans-serif;
        }
        .ft{
          background:var(--black);color:#e8eaf2;
          font-family:var(--f);
          border-top:1px solid var(--bdd);
          padding:5.5rem 1.5rem 0;
          position:relative;overflow:hidden;
        }
        /* top accent line */
        .ft::before{
          content:'';position:absolute;top:0;left:50%;transform:translateX(-50%);
          width:480px;height:1px;
          background:linear-gradient(90deg,transparent,rgba(37,99,235,.55),transparent);
        }
        /* ambient glow */
        .ft::after{
          content:'';position:absolute;top:-160px;left:50%;transform:translateX(-50%);
          width:600px;height:320px;
          background:radial-gradient(ellipse,rgba(37,99,235,.06),transparent 70%);
          pointer-events:none;
        }

        .ft-inner{max-width:1160px;margin:0 auto;position:relative;z-index:1}

        /* MAIN GRID */
        .ft-grid{
          display:grid;grid-template-columns:1.6fr 1fr 1fr 1.2fr;
          gap:4.5rem;padding-bottom:4.5rem;
          border-bottom:1px solid var(--bdd);
        }

        /* BRAND */
        .ft-logo-wrap{display:flex;align-items:center;gap:13px;margin-bottom:1.25rem;cursor:pointer}
        .ft-logo-img{
          height:50px;width:auto;object-fit:contain;
          filter:drop-shadow(0 0 10px rgba(37,99,235,.35)) brightness(1.15);
          transition:filter .3s ease,transform .3s ease;
        }
        .ft-logo-wrap:hover .ft-logo-img{
          filter:drop-shadow(0 0 18px rgba(37,99,235,.6)) brightness(1.3);
          transform:scale(1.04);
        }
        .ft-logo-txt{font-size:1.1rem;font-weight:800;color:#fff;letter-spacing:-.025em;display:none}
        .ft-logo-txt span{color:var(--blue2)}
        .ft-tagline{font-size:.84rem;line-height:1.8;color:var(--txm);font-weight:300;max-width:255px;margin-bottom:2rem}

        /* socials */
        .ft-socials{display:flex;gap:.5rem}
        .ft-soc{
          width:34px;height:34px;border-radius:8px;
          border:1px solid var(--bdd);background:rgba(255,255,255,.03);
          color:rgba(255,255,255,.3);display:flex;align-items:center;justify-content:center;
          text-decoration:none;transition:all .2s ease;
        }
        .ft-soc:hover{border-color:rgba(37,99,235,.45);background:rgba(37,99,235,.12);color:var(--blue2);transform:translateY(-2px)}

        /* COLUMNS */
        .ft-col-lbl{
          font-size:.65rem;font-weight:800;letter-spacing:.18em;text-transform:uppercase;
          color:var(--blue2);margin-bottom:1.25rem;display:block;
        }
        .ft-links{list-style:none;padding:0;margin:0;display:flex;flex-direction:column;gap:.58rem}
        .ft-link{
          font-size:.84rem;color:var(--txm);text-decoration:none;font-weight:400;
          transition:all .2s ease;cursor:pointer;
          background:none;border:none;padding:0;font-family:var(--f);text-align:left;
          display:inline-block;
        }
        .ft-link:hover{color:#e8eaf2;transform:translateX(3px)}

        /* CONTACT COL */
        .ft-contact-items{display:flex;flex-direction:column;gap:.85rem;margin-bottom:1.5rem}
        .ft-ci{
          display:flex;align-items:flex-start;gap:.75rem;
          font-size:.82rem;color:var(--txm);line-height:1.55;
          font-weight:300;text-decoration:none;transition:color .2s;
        }
        .ft-ci:hover{color:#e8eaf2}
        .ft-ci svg{color:var(--blue2);flex-shrink:0;margin-top:2px;opacity:.7}

        /* map */
        .ft-map{border-radius:10px;overflow:hidden;border:1px solid var(--bdd);height:140px}
        .ft-map iframe{width:100%;height:100%;border:0;filter:grayscale(1) invert(.88) hue-rotate(180deg) brightness(.7) contrast(.88)}

        /* BOTTOM BAR */
        .ft-bottom{
          padding:1.5rem 0;
          display:flex;align-items:center;justify-content:space-between;
          flex-wrap:wrap;gap:.5rem;
        }
        .ft-copy{font-size:.75rem;color:rgba(255,255,255,.22);font-weight:300}
        .ft-bottom-links{display:flex;gap:1.5rem}
        .ft-blink{font-size:.75rem;color:rgba(255,255,255,.22);text-decoration:none;transition:color .2s}
        .ft-blink:hover{color:rgba(255,255,255,.55)}

        @media(max-width:960px){
          .ft-grid{grid-template-columns:1fr 1fr;gap:2.5rem}
          .ft-logo-txt{display:block}
          .ft-logo-img{height:42px}
        }
        @media(max-width:540px){
          .ft-grid{grid-template-columns:1fr;gap:2rem}
          .ft-bottom{flex-direction:column;text-align:center}
        }
      `}</style>

      <div className="ft-inner">
        <div className="ft-grid">

          {/* Brand */}
          <div>
            <div className="ft-logo-wrap" onClick={() => window.location.href = "/"}>
              <img
                src="/images/123.png" alt="WayForward IT" className="ft-logo-img"
                onError={(e) => { e.target.style.display = "none"; e.target.nextSibling.style.display = "block"; }}
              />
              <span className="ft-logo-txt" style={{ display: "none" }}>Way<span>Forward</span> IT</span>
            </div>
            <p className="ft-tagline">
              Empowering businesses with top-quality IT services and innovative solutions for the digital future.
            </p>
            <div className="ft-socials">
              {[
                { I: Linkedin, href: "https://www.linkedin.com/company/wayforwardit" },
                { I: Twitter, href: "https://twitter.com" },
                { I: Facebook, href: "https://facebook.com" },
                { I: Instagram, href: "https://instagram.com" },
              ].map(({ I, href }, i) => (
                <a key={i} href={href} target="_blank" rel="noreferrer" className="ft-soc"><I size={15} /></a>
              ))}
            </div>
          </div>

          {/* Company */}
          <div>
            <span className="ft-col-lbl">Company</span>
            <ul className="ft-links">
              {[{ l: "About Us", h: "/#about" }, { l: "Services", h: "/services" }, { l: "Products", h: "/products" }, { l: "Contact", h: "/contact" }].map(({ l, h }) => (
                <li key={l}><a href={h} className="ft-link">{l}</a></li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <span className="ft-col-lbl">Services</span>
            <ul className="ft-links">
              {["Custom Software", "Cloud Solutions", "Cybersecurity", "Mobile Apps", "Data Analytics", "IT Support"].map(s => (
                <li key={s}><a href="/services" className="ft-link">{s}</a></li>
              ))}
            </ul>
          </div>

          {/* Contact + Map */}
          <div>
            <span className="ft-col-lbl">Contact</span>
            <div className="ft-contact-items">
              <a href="mailto:wayforwardit@gmail.com" className="ft-ci"><Mail size={14} />wayforwardit@gmail.com</a>
              <a href="tel:+15551234567" className="ft-ci"><Phone size={14} />+1 (555) 123-4567</a>
              <div className="ft-ci"><MapPin size={14} /><span>5900 Balcones Drive #27580<br />Austin, TX 78731</span></div>
            </div>
            <div className="ft-map">
              <iframe
                title="WayForward IT Location"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d11076468.150032954!2d-105.5003743!3d31.9685987!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x864c19f16da9e6d1%3A0x65b1b39d8b8d1e51!2sTexas%2C%20USA!5e0!3m2!1sen!2s!4v1675862992024!5m2!1sen!2s"
                allowFullScreen="" loading="lazy"
              />
            </div>
          </div>
        </div>

        <div className="ft-bottom">
          <p className="ft-copy">© 2025 WayForward IT. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}
